
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ocean-smart-electrical-panel-40",
      function () {
        return require("private-next-pages/ocean-smart-electrical-panel-40/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ocean-smart-electrical-panel-40"])
      });
    }
  